import { updateKeyInStore } from 'App';
import { MiscellaneousInformationStateValues, updateKey } from '../slice';

export const uploadFields:
  | IBaseField<keyof MiscellaneousInformationStateValues>
  | {}[] = [
  {
    name: 'pleaseUploadACopyOfAllYourCorrespondenceFromIrsOrStateTaxAuthority',
    label:
      'Please upload a copy of all your correspondence from IRS or State Tax Authority.',
    type: 'upload',
    effect: updateKeyInStore(updateKey),
    comment: true,
    predicate: (v: any) => v === 'no',
    dependentOn:
      'taxQuestionnaire.additionalQuestions.miscellaneousInformation.values.haveYouAlreadySharedThatCorrespondenceWithUs',
  },
];
